import ClinicApi from '@/api/clinicApi';
import { ClinicCreate, ClinicResponse } from '@/schema/clinic';
import { PageResponse } from '@/schema/page';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

// Get all clinics (paginated)
export const useClinics = (page: number, size: number) => {
  return useQuery<PageResponse<ClinicResponse>>({
    queryKey: ['clinics', page, size],
    queryFn: () => ClinicApi.getAll(page, size),
  });
};

// Get single clinic by ID
export const useClinic = (id: string) => {
  return useQuery<ClinicResponse>({
    queryKey: ['clinic', id],
    queryFn: () => ClinicApi.getById(id),
  });
};

// Create a new clinic
export const useCreateClinic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ClinicCreate) => ClinicApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinics'] });
    },
  });
};

// Delete a clinic by ID
export const useDeleteClinic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => ClinicApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinics'] });
    },
  });
};
